import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70eca9d3&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/form/_form.scss?vue&type=style&index=0&id=70eca9d3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eca9d3",
  null
  
)

export default component.exports